import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  content: {
    background: "#e6e7e8",
    height: 60,
    display: "flex",
    width: "100%",
    fontFamily: "Gotham Rounded",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "2em",
    "& a": {
      textDecoration: "none",
      color: "inherit",
      margin: "0 5px",
    },
    "& i": {
      margin: "0 8px",
    },
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      flexWrap: "wrap",
      padding: "1em 0",
      height: "auto",
    },
  },
  rootLamina: {
    marginTop: 80,
  },
}));

const BannerFooter = ({
  anterior,
  siguiente,
  anteriorEnlace,
  siguienteEnlace,
  active,
  history,
}) => {
  const classes = useStyles();
  const redirectPage = (page) => {
    history.push(page);
  };
  return (
    <Container maxWidth="md" className={classes.rootLamina}>
      <div className={classes.content}>
        <div className={classes.contentLink}>
          {anterior && (
            <Button variant="text" onClick={() => redirectPage(anteriorEnlace)}>
              <i className="fas fa-chevron-left"></i>
              {anterior}
            </Button>
          )}
        </div>
        <div className={classes.contentLink}>
          {siguiente && (
            <Button
              variant="text"
              disabled={!active}
              onClick={() => redirectPage(siguienteEnlace)}
            >
              {siguiente}
              <i className="fas fa-chevron-right"></i>
            </Button>
          )}
        </div>
      </div>
    </Container>
  );
};

BannerFooter.propTypes = {
  anterior: PropTypes.string,
  siguiente: PropTypes.string,
  anteriorEnlace: PropTypes.string,
  siguienteEnlace: PropTypes.string,
  active: PropTypes.bool,
  history: PropTypes.object,
};

export default withRouter(BannerFooter);
